import { useCallback, useEffect, useState } from 'react';
import { adminGetArchive } from 'services/user';
import { SIZE_PAGE_CONTROL_PANEL } from 'const/paging';
import { useAsyncCallback } from 'hooks/useAsyncCallback';
import { GridPaginationModel, GridRowParams } from '@mui/x-data-grid';
import { User } from 'types/user';
import { useNavigate } from 'react-router-dom';
import { useDebounce } from 'use-debounce';

export const useArchivePage = () => {
  const [rows, setRows] = useState<User[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchArchives = useCallback(
    async ({ page, keyword }: { page: number; keyword?: string }) => {
      setLoading(true);
      try {
        const data = await adminGetArchive({
          page,
          size: SIZE_PAGE_CONTROL_PANEL,
          searchText: keyword
        });
        setRows(data.archives);
        setTotal(data.total);
      } finally {
        setLoading(false);
      }
    },
    []
  );
  const [searchText, setSearchText] = useState<string>('');
  const [debouncedSearchText] = useDebounce(searchText, 1000);

  const { asyncCallback: asyncFetchArchives } = useAsyncCallback(fetchArchives, []);

  useEffect(() => {
    asyncFetchArchives({ page, keyword: debouncedSearchText });
  }, [debouncedSearchText, page]);

  const handlePaginationModelChange = useCallback(
    async (newPaginationModel: GridPaginationModel) => {
      const newPage = newPaginationModel.page + 1;
      setPage(newPage);
    },
    []
  );
  const handleRowArchiveClick = (params: GridRowParams) => {
    params.row.file.seizureReports?.[0]?.id
      ? navigate(`/admin/archive/${params.row.file.seizureReports?.[0]?.id}`)
      : navigate(`/admin/archive/file/${params.row.file.id}`);
  };
  return {
    handleRowArchiveClick,
    rows,
    total,
    page,
    loading,
    handlePaginationModelChange,
    searchText,
    setSearchText
  };
};
